import { COUNTRY_PRICING } from '../config/pricing'
import { countryManager } from './CountryManager'
import { logger } from './logger'

// Ideally we shouldn't use this local pricing config, I keep it to avoid breaking changes in the following cases:
// 1. Get currency from local config if it failed loading the prices in the server
// 2. VAT calculations - I'm not sure the calculation is correct so I'll check with data
function _getPricing(country) {
  const lowercaseCountryPricing = countryManager
    .getPricingCountry(country)
    .toLowerCase()
  if (!COUNTRY_PRICING[lowercaseCountryPricing]) {
    logger.error('Error - no Country Pricing countryPricing', null, {
      lowercaseCountryPricing,
    })
    return null
  }
  return COUNTRY_PRICING[lowercaseCountryPricing]
}

export function getVATPercentage() {
  const pricing = _getPricing()
  return pricing?.vatPercentIncludedInPrice || 0
}

export function getCurrency(country) {
  return _getPricing(country).currency
}
